export default "__VITE_ASSET__tAgtTE6k__"